export default "__VITE_ASSET__DEyiL5hw__"